// Full customer-facing UI dictionary across all 10 supported languages.
// Product / category / concern / combo / collection names come from the DB (per-language)
// and are read via labelOf(). Everything else is keyed in here.

const SUPPORTED = ["en", "hi", "kn", "ta", "ml", "te", "bn", "mr", "gu", "other"];

const en = {
  "brand.name": "Elvis Beauty",
  "hero.title1": "Your skin,",
  "hero.title2": "your ritual.",
  "hero.subtitle": "A 60-second concierge to find products picked for your concerns — not someone else's.",
  "hero.pickLang": "Pick your language",
  "hero.availability": "Available in 10 languages. You can switch anytime from the top of the screen.",
  "step.language": "Language",
  "step.category": "Concerns",
  "step.concern": "Concern",
  "step.profile": "About you",
  "step.basic": "Your details",
  "step.routine": "Recommendations",
  "step.delivery": "Delivery",
  "step.payment": "Payment",
  "step.review": "Review",
  "category.title": "What do you want to work on?",
  "category.subtitle": "Pick one or more — we'll tailor a routine.",
  "category.multiselect": "Select multiple",
  "category.pickone": "Pick at least one",
  "category.selected": "selected",
  "concern.title": "Your concern",
  "concern.subtitle": "What do you want to work on?",
  "profile.name": "Your name",
  "profile.age": "Age",
  "profile.gender": "Gender",
  "profile.title": "Tell us about you",
  "profile.subtitle": "So we tailor the right routine.",
  "basic.title": "Hi! Let's get started.",
  "basic.subtitle": "Just a few quick details before we personalise.",
  "basic.phone": "WhatsApp phone",
  "gender.female": "Female",
  "gender.male": "Male",
  "gender.other": "Other",
  "recs.title": "Picked for you",
  "recs.subtitle": "Curated based on your concerns.",
  "recs.combos": "Combos & kits",
  "recs.collections": "Collections",
  "recs.related": "All products",
  "recs.empty": "Add at least one item to continue.",
  "routine.added": "Added",
  "routine.add": "Add",
  "routine.total": "Order total",
  "routine.title": "Your recommended routine",
  "routine.subtitle": "Hand-picked for you. Add or remove anything.",
  "routine.empty": "Pick at least one product to continue.",
  "delivery.title": "Where do we ship?",
  "delivery.subtitle": "We'll deliver discreetly to your door.",
  "delivery.phone": "WhatsApp phone",
  "delivery.alt": "Alternate phone (optional)",
  "delivery.address": "Full address",
  "delivery.city": "City",
  "delivery.district": "District",
  "delivery.state": "State",
  "delivery.pincode": "Pincode",
  "payment.title": "How would you like to pay?",
  "payment.online": "Online payment",
  "payment.online.note": "FREE delivery",
  "payment.cod": "Cash on Delivery",
  "payment.cod.note": "Pay at your door",
  "payment.free": "FREE",
  "review.title": "Review your order",
  "review.subtitle": "Confirm everything looks right, then continue on WhatsApp.",
  "review.items": "Items",
  "review.delivery": "Delivery",
  "review.payment": "Payment",
  "review.send": "Send order on WhatsApp",
  "review.consent": "I agree to be contacted on WhatsApp regarding this order.",
  "review.yourdetails": "Your details",
  "review.concerns": "Concerns",
  "review.name": "Name",
  "review.age": "Age",
  "review.phone": "Phone",
  "review.qty": "Qty",
  "confirm.title": "Order placed",
  "confirm.subtitle": "We've opened WhatsApp with your full order pre-filled.",
  "confirm.confirmed": "Confirmed",
  "confirm.ref": "Order reference",
  "confirm.rep": "Your sales advisor",
  "confirm.reopen": "Reopen WhatsApp",
  "confirm.again": "Place another order",
  "common.back": "Back",
  "common.continue": "Continue",
  "common.skip": "Skip",
  "common.required": "Required",
  "common.optional": "optional",
  "common.step": "Step",
  "common.of": "of",
  "common.qty": "Qty",
  "common.save": "Save",
  "common.sending": "Sending…",
  "common.loading": "Loading…",
  "sticky.items": "items",
  "sticky.item": "item",
};

const hi = {
  "brand.name": "एल्विस ब्यूटी",
  "hero.title1": "आपकी त्वचा,",
  "hero.title2": "आपकी रूटीन।",
  "hero.subtitle": "60 सेकंड की कंसीयज सेवा — आपकी समस्याओं के लिए चुने गए उत्पाद, किसी और के लिए नहीं।",
  "hero.pickLang": "अपनी भाषा चुनें",
  "hero.availability": "10 भाषाओं में उपलब्ध। आप कभी भी ऊपर से भाषा बदल सकते हैं।",
  "step.language": "भाषा", "step.category": "समस्याएं", "step.concern": "समस्या",
  "step.profile": "आपके बारे में", "step.basic": "आपकी जानकारी", "step.routine": "सुझाव",
  "step.delivery": "डिलीवरी", "step.payment": "भुगतान", "step.review": "समीक्षा",
  "category.title": "आप किस पर काम करना चाहते हैं?",
  "category.subtitle": "एक या अधिक चुनें — हम रूटीन तैयार करेंगे।",
  "category.multiselect": "एक से ज़्यादा चुनें",
  "category.pickone": "कम से कम एक चुनें",
  "category.selected": "चुने गए",
  "concern.title": "आपकी समस्या", "concern.subtitle": "आप किस पर काम करना चाहते हैं?",
  "profile.name": "आपका नाम", "profile.age": "उम्र", "profile.gender": "लिंग",
  "profile.title": "अपने बारे में बताएं", "profile.subtitle": "ताकि हम सही रूटीन सुझा सकें।",
  "basic.title": "नमस्ते! चलिए शुरू करते हैं।",
  "basic.subtitle": "बस कुछ जानकारी, फिर हम सुझाव देंगे।",
  "basic.phone": "व्हाट्सएप फ़ोन",
  "gender.female": "महिला", "gender.male": "पुरुष", "gender.other": "अन्य",
  "recs.title": "आपके लिए चुना गया", "recs.subtitle": "आपकी समस्याओं के आधार पर।",
  "recs.combos": "कॉम्बो और किट", "recs.collections": "कलेक्शन", "recs.related": "सभी उत्पाद",
  "recs.empty": "जारी रखने के लिए कम से कम एक उत्पाद जोड़ें।",
  "routine.added": "जोड़ा गया", "routine.add": "जोड़ें", "routine.total": "ऑर्डर कुल",
  "routine.title": "आपकी अनुशंसित रूटीन", "routine.subtitle": "आपके लिए चुनी गई। जोड़ें या हटाएं।",
  "routine.empty": "जारी रखने के लिए कम से कम एक उत्पाद चुनें।",
  "delivery.title": "डिलीवरी कहाँ?", "delivery.subtitle": "हम आपके दरवाजे तक पहुँचाएंगे।",
  "delivery.phone": "व्हाट्सएप फ़ोन", "delivery.alt": "वैकल्पिक फ़ोन (वैकल्पिक)",
  "delivery.address": "पूरा पता", "delivery.city": "शहर", "delivery.district": "जिला",
  "delivery.state": "राज्य", "delivery.pincode": "पिनकोड",
  "payment.title": "भुगतान कैसे करेंगे?",
  "payment.online": "ऑनलाइन भुगतान", "payment.online.note": "मुफ्त डिलीवरी",
  "payment.cod": "कैश ऑन डिलीवरी", "payment.cod.note": "घर पर भुगतान करें", "payment.free": "मुफ्त",
  "review.title": "अपने ऑर्डर की समीक्षा करें",
  "review.subtitle": "सब कुछ सही है तो व्हाट्सएप पर जारी रखें।",
  "review.items": "उत्पाद", "review.delivery": "डिलीवरी", "review.payment": "भुगतान",
  "review.send": "व्हाट्सएप पर ऑर्डर भेजें",
  "review.consent": "मैं इस ऑर्डर के लिए व्हाट्सएप पर संपर्क करने की सहमति देता हूँ।",
  "review.yourdetails": "आपकी जानकारी", "review.concerns": "समस्याएं",
  "review.name": "नाम", "review.age": "उम्र", "review.phone": "फ़ोन", "review.qty": "मात्रा",
  "confirm.title": "ऑर्डर हो गया",
  "confirm.subtitle": "हमने आपके पूरे ऑर्डर के साथ व्हाट्सएप खोल दिया है।",
  "confirm.confirmed": "पुष्टि हुई", "confirm.ref": "ऑर्डर संदर्भ",
  "confirm.rep": "आपका सलाहकार", "confirm.reopen": "व्हाट्सएप फिर से खोलें",
  "confirm.again": "एक और ऑर्डर करें",
  "common.back": "वापस", "common.continue": "जारी रखें", "common.skip": "छोड़ें",
  "common.required": "आवश्यक", "common.optional": "वैकल्पिक", "common.step": "चरण",
  "common.of": "/", "common.qty": "मात्रा", "common.save": "सेव करें",
  "common.sending": "भेजा जा रहा है…", "common.loading": "लोड हो रहा है…",
  "sticky.items": "वस्तुएं", "sticky.item": "वस्तु",
};

const kn = {
  "brand.name": "ಎಲ್ವಿಸ್ ಬ್ಯೂಟಿ",
  "hero.title1": "ನಿಮ್ಮ ಚರ್ಮ,", "hero.title2": "ನಿಮ್ಮ ಆರೈಕೆ.",
  "hero.subtitle": "60 ಸೆಕೆಂಡ್‌ಗಳ ಸಲಹೆಗಾರ — ನಿಮ್ಮ ಸಮಸ್ಯೆಗಳಿಗೆ ಆಯ್ಕೆ ಮಾಡಲಾದ ಉತ್ಪನ್ನಗಳು.",
  "hero.pickLang": "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  "hero.availability": "10 ಭಾಷೆಗಳಲ್ಲಿ ಲಭ್ಯ. ನೀವು ಯಾವಾಗ ಬೇಕಾದರೂ ಮೇಲ್ಭಾಗದಿಂದ ಬದಲಾಯಿಸಬಹುದು.",
  "step.language": "ಭಾಷೆ", "step.category": "ಸಮಸ್ಯೆಗಳು", "step.concern": "ಸಮಸ್ಯೆ",
  "step.profile": "ನಿಮ್ಮ ಬಗ್ಗೆ", "step.basic": "ನಿಮ್ಮ ವಿವರಗಳು", "step.routine": "ಶಿಫಾರಸುಗಳು",
  "step.delivery": "ವಿತರಣೆ", "step.payment": "ಪಾವತಿ", "step.review": "ಪರಿಶೀಲನೆ",
  "category.title": "ನೀವು ಏನು ಮೇಲೆ ಕೆಲಸ ಮಾಡಲು ಬಯಸುತ್ತೀರಿ?",
  "category.subtitle": "ಒಂದು ಅಥವಾ ಹೆಚ್ಚು ಆಯ್ಕೆಮಾಡಿ — ನಾವು ಆರೈಕೆಯನ್ನು ಹೊಂದಿಸುತ್ತೇವೆ.",
  "category.multiselect": "ಒಂದಕ್ಕಿಂತ ಹೆಚ್ಚು ಆಯ್ಕೆಮಾಡಿ",
  "category.pickone": "ಕನಿಷ್ಠ ಒಂದು ಆಯ್ಕೆಮಾಡಿ", "category.selected": "ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ",
  "concern.title": "ನಿಮ್ಮ ಸಮಸ್ಯೆ", "concern.subtitle": "ನೀವು ಏನು ಮೇಲೆ ಕೆಲಸ ಮಾಡಲು ಬಯಸುತ್ತೀರಿ?",
  "profile.name": "ನಿಮ್ಮ ಹೆಸರು", "profile.age": "ವಯಸ್ಸು", "profile.gender": "ಲಿಂಗ",
  "profile.title": "ನಿಮ್ಮ ಬಗ್ಗೆ ಹೇಳಿ", "profile.subtitle": "ನಾವು ಸರಿಯಾದ ಆರೈಕೆ ಸೂಚಿಸಲು.",
  "basic.title": "ಹಲೋ! ಪ್ರಾರಂಭಿಸೋಣ.",
  "basic.subtitle": "ವೈಯಕ್ತೀಕರಿಸುವ ಮೊದಲು ಕೆಲವು ಬೇಗ ವಿವರಗಳು.",
  "basic.phone": "ವಾಟ್ಸ್‌ಆಪ್ ಫೋನ್",
  "gender.female": "ಮಹಿಳೆ", "gender.male": "ಪುರುಷ", "gender.other": "ಇತರೆ",
  "recs.title": "ನಿಮಗಾಗಿ ಆಯ್ಕೆ", "recs.subtitle": "ನಿಮ್ಮ ಸಮಸ್ಯೆಗಳ ಆಧಾರದ ಮೇಲೆ.",
  "recs.combos": "ಕಾಂಬೋ ಮತ್ತು ಕಿಟ್‌ಗಳು", "recs.collections": "ಸಂಗ್ರಹಗಳು",
  "recs.related": "ಎಲ್ಲಾ ಉತ್ಪನ್ನಗಳು", "recs.empty": "ಮುಂದುವರಿಸಲು ಒಂದನ್ನಾದರೂ ಸೇರಿಸಿ.",
  "routine.added": "ಸೇರಿಸಲಾಗಿದೆ", "routine.add": "ಸೇರಿಸಿ", "routine.total": "ಆದೇಶ ಒಟ್ಟು",
  "routine.title": "ನಿಮ್ಮ ಶಿಫಾರಸು ಮಾಡಿದ ಆರೈಕೆ",
  "routine.subtitle": "ನಿಮಗಾಗಿ ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ.",
  "routine.empty": "ಮುಂದುವರಿಸಲು ಒಂದು ಉತ್ಪನ್ನವನ್ನಾದರೂ ಆಯ್ಕೆಮಾಡಿ.",
  "delivery.title": "ಎಲ್ಲಿಗೆ ಶಿಪ್ ಮಾಡಬೇಕು?", "delivery.subtitle": "ನಾವು ನಿಮ್ಮ ಬಾಗಿಲಿಗೆ ತಲುಪಿಸುತ್ತೇವೆ.",
  "delivery.phone": "ವಾಟ್ಸ್‌ಆಪ್ ಫೋನ್", "delivery.alt": "ಪರ್ಯಾಯ ಫೋನ್ (ಐಚ್ಛಿಕ)",
  "delivery.address": "ಪೂರ್ಣ ವಿಳಾಸ", "delivery.city": "ನಗರ", "delivery.district": "ಜಿಲ್ಲೆ",
  "delivery.state": "ರಾಜ್ಯ", "delivery.pincode": "ಪಿನ್‌ಕೋಡ್",
  "payment.title": "ನೀವು ಹೇಗೆ ಪಾವತಿಸಲು ಬಯಸುತ್ತೀರಿ?",
  "payment.online": "ಆನ್‌ಲೈನ್ ಪಾವತಿ", "payment.online.note": "ಉಚಿತ ವಿತರಣೆ",
  "payment.cod": "ವಿತರಣೆಗೆ ನಗದು", "payment.cod.note": "ಬಾಗಿಲಿಗೆ ಪಾವತಿಸಿ", "payment.free": "ಉಚಿತ",
  "review.title": "ನಿಮ್ಮ ಆದೇಶ ಪರಿಶೀಲಿಸಿ",
  "review.subtitle": "ಎಲ್ಲವೂ ಸರಿಯಾಗಿದ್ದರೆ ವಾಟ್ಸ್‌ಆಪ್‌ನಲ್ಲಿ ಮುಂದುವರಿಸಿ.",
  "review.items": "ಉತ್ಪನ್ನಗಳು", "review.delivery": "ವಿತರಣೆ", "review.payment": "ಪಾವತಿ",
  "review.send": "ವಾಟ್ಸ್‌ಆಪ್‌ನಲ್ಲಿ ಆದೇಶ ಕಳುಹಿಸಿ",
  "review.consent": "ಈ ಆದೇಶದ ಬಗ್ಗೆ ವಾಟ್ಸ್‌ಆಪ್‌ನಲ್ಲಿ ಸಂಪರ್ಕಿಸಲು ನಾನು ಸಮ್ಮತಿಸುತ್ತೇನೆ.",
  "review.yourdetails": "ನಿಮ್ಮ ವಿವರಗಳು", "review.concerns": "ಸಮಸ್ಯೆಗಳು",
  "review.name": "ಹೆಸರು", "review.age": "ವಯಸ್ಸು", "review.phone": "ಫೋನ್", "review.qty": "ಪ್ರಮಾಣ",
  "confirm.title": "ಆದೇಶ ಸಿದ್ಧವಾಗಿದೆ",
  "confirm.subtitle": "ನಿಮ್ಮ ಪೂರ್ಣ ಆದೇಶದೊಂದಿಗೆ ವಾಟ್ಸ್‌ಆಪ್ ತೆರೆಯಲಾಗಿದೆ.",
  "confirm.confirmed": "ದೃಢೀಕರಿಸಲಾಗಿದೆ", "confirm.ref": "ಆದೇಶ ಉಲ್ಲೇಖ",
  "confirm.rep": "ನಿಮ್ಮ ಸಲಹೆಗಾರ", "confirm.reopen": "ವಾಟ್ಸ್‌ಆಪ್ ಮತ್ತೆ ತೆರೆಯಿರಿ",
  "confirm.again": "ಮತ್ತೊಂದು ಆದೇಶ ಮಾಡಿ",
  "common.back": "ಹಿಂದೆ", "common.continue": "ಮುಂದುವರಿಸಿ", "common.skip": "ಬಿಟ್ಟುಬಿಡಿ",
  "common.required": "ಅವಶ್ಯಕ", "common.optional": "ಐಚ್ಛಿಕ", "common.step": "ಹಂತ",
  "common.of": "/", "common.qty": "ಪ್ರಮಾಣ", "common.save": "ಉಳಿಸಿ",
  "common.sending": "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…", "common.loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
  "sticky.items": "ವಸ್ತುಗಳು", "sticky.item": "ವಸ್ತು",
};

const ta = {
  "brand.name": "எல்விஸ் பியூட்டி",
  "hero.title1": "உங்கள் சருமம்,", "hero.title2": "உங்கள் வழக்கம்.",
  "hero.subtitle": "60 விநாடி கன்சீர்ஜ் — உங்கள் கவலைகளுக்கு தேர்ந்தெடுக்கப்பட்ட பொருட்கள்.",
  "hero.pickLang": "உங்கள் மொழியைத் தேர்வுசெய்க",
  "hero.availability": "10 மொழிகளில் கிடைக்கும். மேலே எப்போது வேண்டுமானாலும் மாற்றலாம்.",
  "step.language": "மொழி", "step.category": "கவலைகள்", "step.concern": "கவலை",
  "step.profile": "உங்களைப் பற்றி", "step.basic": "உங்கள் விவரங்கள்", "step.routine": "பரிந்துரைகள்",
  "step.delivery": "டெலிவரி", "step.payment": "கட்டணம்", "step.review": "சரிபார்ப்பு",
  "category.title": "எதில் கவனம் செலுத்த விரும்புகிறீர்கள்?",
  "category.subtitle": "ஒன்று அல்லது அதற்கு மேற்பட்டதைத் தேர்ந்தெடுக்கவும்.",
  "category.multiselect": "பலவற்றைத் தேர்வுசெய்க",
  "category.pickone": "குறைந்தது ஒன்றைத் தேர்வுசெய்க", "category.selected": "தேர்வு செய்யப்பட்டது",
  "concern.title": "உங்கள் கவலை", "concern.subtitle": "எதில் கவனம் செலுத்த விரும்புகிறீர்கள்?",
  "profile.name": "உங்கள் பெயர்", "profile.age": "வயது", "profile.gender": "பாலினம்",
  "profile.title": "உங்களைப் பற்றி சொல்லுங்கள்", "profile.subtitle": "சரியான வழக்கத்தை வடிவமைக்க.",
  "basic.title": "வணக்கம்! தொடங்குவோம்.",
  "basic.subtitle": "தனிப்பயனாக்க முன் சில விரைவான விவரங்கள்.",
  "basic.phone": "வாட்ஸ்அப் தொலைபேசி",
  "gender.female": "பெண்", "gender.male": "ஆண்", "gender.other": "மற்றவை",
  "recs.title": "உங்களுக்காக", "recs.subtitle": "உங்கள் கவலைகளின் அடிப்படையில்.",
  "recs.combos": "காம்போக்கள்", "recs.collections": "தொகுப்புகள்", "recs.related": "அனைத்து பொருட்கள்",
  "recs.empty": "தொடர குறைந்தது ஒன்றைச் சேர்க்கவும்.",
  "routine.added": "சேர்க்கப்பட்டது", "routine.add": "சேர்", "routine.total": "ஆர்டர் மொத்தம்",
  "routine.title": "உங்களுக்கான பரிந்துரை", "routine.subtitle": "உங்களுக்காக கையால் தேர்வு.",
  "routine.empty": "தொடர குறைந்தது ஒரு பொருளைத் தேர்வுசெய்க.",
  "delivery.title": "எங்கே அனுப்ப வேண்டும்?", "delivery.subtitle": "உங்கள் வீட்டுக்கு அனுப்புவோம்.",
  "delivery.phone": "வாட்ஸ்அப் தொலைபேசி", "delivery.alt": "மாற்று எண் (விருப்பம்)",
  "delivery.address": "முழு முகவரி", "delivery.city": "நகரம்", "delivery.district": "மாவட்டம்",
  "delivery.state": "மாநிலம்", "delivery.pincode": "பின்கோடு",
  "payment.title": "எப்படி பணம் செலுத்த விரும்புகிறீர்கள்?",
  "payment.online": "ஆன்லைன் கட்டணம்", "payment.online.note": "இலவச டெலிவரி",
  "payment.cod": "டெலிவரியில் பணம்", "payment.cod.note": "உங்கள் வீட்டில் செலுத்துங்கள்", "payment.free": "இலவசம்",
  "review.title": "உங்கள் ஆர்டரை சரிபார்க்கவும்",
  "review.subtitle": "எல்லாம் சரியாக இருந்தால் வாட்ஸ்அப்பில் தொடரவும்.",
  "review.items": "பொருட்கள்", "review.delivery": "டெலிவரி", "review.payment": "கட்டணம்",
  "review.send": "வாட்ஸ்அப்பில் ஆர்டரை அனுப்பு",
  "review.consent": "இந்த ஆர்டர் தொடர்பாக வாட்ஸ்அப்பில் தொடர்பு கொள்ள ஒப்புக்கொள்கிறேன்.",
  "review.yourdetails": "உங்கள் விவரங்கள்", "review.concerns": "கவலைகள்",
  "review.name": "பெயர்", "review.age": "வயது", "review.phone": "தொலைபேசி", "review.qty": "எண்ணிக்கை",
  "confirm.title": "ஆர்டர் வெற்றிகரம்",
  "confirm.subtitle": "உங்கள் முழு ஆர்டருடன் வாட்ஸ்அப் திறக்கப்பட்டது.",
  "confirm.confirmed": "உறுதிப்படுத்தப்பட்டது", "confirm.ref": "ஆர்டர் குறிப்பு",
  "confirm.rep": "உங்கள் ஆலோசகர்", "confirm.reopen": "வாட்ஸ்அப் மீண்டும் திற",
  "confirm.again": "மற்றொரு ஆர்டர்",
  "common.back": "பின்", "common.continue": "தொடர்", "common.skip": "தவிர்",
  "common.required": "தேவை", "common.optional": "விருப்பம்", "common.step": "படி",
  "common.of": "/", "common.qty": "எண்ணிக்கை", "common.save": "சேமி",
  "common.sending": "அனுப்புகிறது…", "common.loading": "ஏற்றுகிறது…",
  "sticky.items": "பொருட்கள்", "sticky.item": "பொருள்",
};

const ml = {
  "brand.name": "എൽവിസ് ബ്യൂട്ടി",
  "hero.title1": "നിങ്ങളുടെ ചർമ്മം,", "hero.title2": "നിങ്ങളുടെ ദിനചര്യ.",
  "hero.subtitle": "60 സെക്കൻഡ് കൺസിയർജ് — നിങ്ങളുടെ ആശങ്കകൾക്കായി തിരഞ്ഞെടുത്ത ഉൽപ്പന്നങ്ങൾ.",
  "hero.pickLang": "നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക",
  "hero.availability": "10 ഭാഷകളിൽ ലഭ്യം. എപ്പോൾ വേണമെങ്കിലും മുകളിൽ നിന്ന് മാറ്റാം.",
  "step.language": "ഭാഷ", "step.category": "ആശങ്കകൾ", "step.concern": "ആശങ്ക",
  "step.profile": "നിങ്ങളെക്കുറിച്ച്", "step.basic": "നിങ്ങളുടെ വിശദാംശങ്ങൾ", "step.routine": "നിർദ്ദേശങ്ങൾ",
  "step.delivery": "ഡെലിവറി", "step.payment": "പേയ്മെൻ്റ്", "step.review": "അവലോകനം",
  "category.title": "എന്തിന് ശ്രദ്ധ കൊടുക്കാം?",
  "category.subtitle": "ഒന്നോ അതിലധികമോ തിരഞ്ഞെടുക്കുക — ഞങ്ങൾ ദിനചര്യ ഒരുക്കാം.",
  "category.multiselect": "ഒന്നിലധികം തിരഞ്ഞെടുക്കുക",
  "category.pickone": "ഒന്നെങ്കിലും തിരഞ്ഞെടുക്കുക", "category.selected": "തിരഞ്ഞെടുത്തു",
  "concern.title": "നിങ്ങളുടെ ആശങ്ക", "concern.subtitle": "എന്തിന് ശ്രദ്ധ കൊടുക്കാം?",
  "profile.name": "നിങ്ങളുടെ പേര്", "profile.age": "പ്രായം", "profile.gender": "ലിംഗം",
  "profile.title": "നിങ്ങളെക്കുറിച്ച് പറയൂ", "profile.subtitle": "ശരിയായ ദിനചര്യ നൽകാൻ.",
  "basic.title": "ഹായ്! തുടങ്ങാം.",
  "basic.subtitle": "വ്യക്തിഗതമാക്കുന്നതിന് മുമ്പ് കുറച്ച് വിശദാംശങ്ങൾ.",
  "basic.phone": "വാട്സ്ആപ്പ് ഫോൺ",
  "gender.female": "സ്ത്രീ", "gender.male": "പുരുഷൻ", "gender.other": "മറ്റുള്ളവ",
  "recs.title": "നിങ്ങൾക്കായി തിരഞ്ഞെടുത്തത്", "recs.subtitle": "നിങ്ങളുടെ ആശങ്കകൾ അനുസരിച്ച്.",
  "recs.combos": "കോംബോകൾ", "recs.collections": "ശേഖരങ്ങൾ", "recs.related": "എല്ലാ ഉൽപ്പന്നങ്ങളും",
  "recs.empty": "തുടരാൻ ഒരെണ്ണമെങ്കിലും ചേർക്കുക.",
  "routine.added": "ചേർത്തു", "routine.add": "ചേർക്കുക", "routine.total": "ഓർഡർ ആകെ",
  "routine.title": "നിങ്ങൾക്കായുള്ള ദിനചര്യ", "routine.subtitle": "നിങ്ങൾക്കായി തിരഞ്ഞെടുത്തത്.",
  "routine.empty": "തുടരാൻ ഒരുൽപ്പന്നം തിരഞ്ഞെടുക്കുക.",
  "delivery.title": "എവിടെ അയക്കണം?", "delivery.subtitle": "നിങ്ങളുടെ വാതിലിലേക്ക് എത്തിക്കും.",
  "delivery.phone": "വാട്സ്ആപ്പ് ഫോൺ", "delivery.alt": "ഇതര ഫോൺ (ഓപ്ഷണൽ)",
  "delivery.address": "പൂർണ്ണ വിലാസം", "delivery.city": "നഗരം", "delivery.district": "ജില്ല",
  "delivery.state": "സംസ്ഥാനം", "delivery.pincode": "പിൻകോഡ്",
  "payment.title": "എങ്ങനെ പണം നൽകാം?",
  "payment.online": "ഓൺലൈൻ പേയ്മെൻ്റ്", "payment.online.note": "സൗജന്യ ഡെലിവറി",
  "payment.cod": "ഡെലിവറിക്ക് പണം", "payment.cod.note": "വാതിലിൽ പണം നൽകുക", "payment.free": "സൗജന്യം",
  "review.title": "നിങ്ങളുടെ ഓർഡർ പരിശോധിക്കുക",
  "review.subtitle": "എല്ലാം ശരിയാണെങ്കിൽ വാട്സ്ആപ്പിൽ തുടരുക.",
  "review.items": "ഇനങ്ങൾ", "review.delivery": "ഡെലിവറി", "review.payment": "പേയ്മെൻ്റ്",
  "review.send": "വാട്സ്ആപ്പിൽ ഓർഡർ അയക്കുക",
  "review.consent": "ഈ ഓർഡറിനെക്കുറിച്ച് വാട്സ്ആപ്പിൽ ബന്ധപ്പെടാൻ ഞാൻ സമ്മതിക്കുന്നു.",
  "review.yourdetails": "നിങ്ങളുടെ വിശദാംശങ്ങൾ", "review.concerns": "ആശങ്കകൾ",
  "review.name": "പേര്", "review.age": "പ്രായം", "review.phone": "ഫോൺ", "review.qty": "എണ്ണം",
  "confirm.title": "ഓർഡർ ചെയ്തു",
  "confirm.subtitle": "നിങ്ങളുടെ ഓർഡറുമായി വാട്സ്ആപ്പ് തുറന്നു.",
  "confirm.confirmed": "സ്ഥിരീകരിച്ചു", "confirm.ref": "ഓർഡർ റഫറൻസ്",
  "confirm.rep": "നിങ്ങളുടെ ഉപദേശകൻ", "confirm.reopen": "വാട്സ്ആപ്പ് വീണ്ടും തുറക്കുക",
  "confirm.again": "മറ്റൊരു ഓർഡർ ചെയ്യുക",
  "common.back": "തിരികെ", "common.continue": "തുടരുക", "common.skip": "ഒഴിവാക്കുക",
  "common.required": "ആവശ്യം", "common.optional": "ഓപ്ഷണൽ", "common.step": "ഘട്ടം",
  "common.of": "/", "common.qty": "എണ്ണം", "common.save": "സേവ് ചെയ്യുക",
  "common.sending": "അയക്കുന്നു…", "common.loading": "ലോഡുചെയ്യുന്നു…",
  "sticky.items": "ഇനങ്ങൾ", "sticky.item": "ഇനം",
};

const te = {
  "brand.name": "ఎల్విస్ బ్యూటీ",
  "hero.title1": "మీ చర్మం,", "hero.title2": "మీ సంరక్షణ.",
  "hero.subtitle": "60 సెకన్ల కన్సియర్జ్ — మీ సమస్యలకు ఎంపిక చేసిన ఉత్పత్తులు.",
  "hero.pickLang": "మీ భాషను ఎంచుకోండి",
  "hero.availability": "10 భాషల్లో అందుబాటులో. ఎప్పుడైనా పైనుండి మార్చండి.",
  "step.language": "భాష", "step.category": "సమస్యలు", "step.concern": "సమస్య",
  "step.profile": "మీ గురించి", "step.basic": "మీ వివరాలు", "step.routine": "సిఫార్సులు",
  "step.delivery": "డెలివరీ", "step.payment": "చెల్లింపు", "step.review": "సమీక్ష",
  "category.title": "మీరు దేనిపై దృష్టి పెట్టాలనుకుంటున్నారు?",
  "category.subtitle": "ఒకటి లేదా ఎక్కువ ఎంచుకోండి — మేము సరిచేస్తాం.",
  "category.multiselect": "ఒకటి కంటే ఎక్కువ ఎంచుకోండి",
  "category.pickone": "కనీసం ఒకటి ఎంచుకోండి", "category.selected": "ఎంచుకున్నవి",
  "concern.title": "మీ సమస్య", "concern.subtitle": "మీరు దేనిపై దృష్టి పెట్టాలనుకుంటున్నారు?",
  "profile.name": "మీ పేరు", "profile.age": "వయస్సు", "profile.gender": "లింగం",
  "profile.title": "మీ గురించి చెప్పండి", "profile.subtitle": "సరైన సంరక్షణ ఇవ్వడానికి.",
  "basic.title": "హాయ్! ప్రారంభిద్దాం.",
  "basic.subtitle": "వ్యక్తిగతీకరించే ముందు కొన్ని వివరాలు.",
  "basic.phone": "వాట్సాప్ ఫోన్",
  "gender.female": "మహిళ", "gender.male": "పురుషుడు", "gender.other": "ఇతర",
  "recs.title": "మీ కోసం ఎంపిక", "recs.subtitle": "మీ సమస్యల ఆధారంగా.",
  "recs.combos": "కాంబోలు", "recs.collections": "సేకరణలు", "recs.related": "అన్ని ఉత్పత్తులు",
  "recs.empty": "కొనసాగడానికి కనీసం ఒకటి జోడించండి.",
  "routine.added": "జోడించబడింది", "routine.add": "జోడించు", "routine.total": "ఆర్డర్ మొత్తం",
  "routine.title": "మీ సిఫారసు చేసిన దినచర్య", "routine.subtitle": "మీ కోసం ఎంపిక చేయబడింది.",
  "routine.empty": "కొనసాగడానికి కనీసం ఒక ఉత్పత్తిని ఎంచుకోండి.",
  "delivery.title": "ఎక్కడ షిప్ చేయాలి?", "delivery.subtitle": "మీ ఇంటికి తీసుకువస్తాం.",
  "delivery.phone": "వాట్సాప్ ఫోన్", "delivery.alt": "ప్రత్యామ్నాయ ఫోన్ (ఐచ్ఛిక)",
  "delivery.address": "పూర్తి చిరునామా", "delivery.city": "నగరం", "delivery.district": "జిల్లా",
  "delivery.state": "రాష్ట్రం", "delivery.pincode": "పిన్‌కోడ్",
  "payment.title": "మీరు ఎలా చెల్లించాలనుకుంటున్నారు?",
  "payment.online": "ఆన్‌లైన్ చెల్లింపు", "payment.online.note": "ఉచిత డెలివరీ",
  "payment.cod": "డెలివరీ వద్ద నగదు", "payment.cod.note": "ఇంటి వద్ద చెల్లించండి", "payment.free": "ఉచితం",
  "review.title": "మీ ఆర్డర్‌ను సమీక్షించండి",
  "review.subtitle": "అన్నీ సరిగా ఉంటే వాట్సాప్‌లో కొనసాగండి.",
  "review.items": "ఉత్పత్తులు", "review.delivery": "డెలివరీ", "review.payment": "చెల్లింపు",
  "review.send": "వాట్సాప్‌లో ఆర్డర్ పంపండి",
  "review.consent": "ఈ ఆర్డర్ గురించి వాట్సాప్‌లో సంప్రదించడానికి అంగీకరిస్తున్నాను.",
  "review.yourdetails": "మీ వివరాలు", "review.concerns": "సమస్యలు",
  "review.name": "పేరు", "review.age": "వయస్సు", "review.phone": "ఫోన్", "review.qty": "పరిమాణం",
  "confirm.title": "ఆర్డర్ ఉంచబడింది",
  "confirm.subtitle": "మీ పూర్తి ఆర్డర్‌తో వాట్సాప్ తెరిచాము.",
  "confirm.confirmed": "నిర్ధారించబడింది", "confirm.ref": "ఆర్డర్ సూచిక",
  "confirm.rep": "మీ సలహాదారు", "confirm.reopen": "వాట్సాప్ మళ్ళీ తెరవండి",
  "confirm.again": "మరో ఆర్డర్ చేయండి",
  "common.back": "వెనుకకు", "common.continue": "కొనసాగించండి", "common.skip": "దాటవేయండి",
  "common.required": "అవసరం", "common.optional": "ఐచ్ఛిక", "common.step": "దశ",
  "common.of": "/", "common.qty": "పరిమాణం", "common.save": "సేవ్ చేయండి",
  "common.sending": "పంపుతోంది…", "common.loading": "లోడ్ అవుతోంది…",
  "sticky.items": "వస్తువులు", "sticky.item": "వస్తువు",
};

const bn = {
  "brand.name": "এলভিস বিউটি",
  "hero.title1": "আপনার ত্বক,", "hero.title2": "আপনার যত্ন.",
  "hero.subtitle": "৬০ সেকেন্ডের কনসিয়ার্জ — আপনার সমস্যার জন্য বাছাই করা পণ্য.",
  "hero.pickLang": "আপনার ভাষা নির্বাচন করুন",
  "hero.availability": "১০টি ভাষায় উপলব্ধ। যেকোনো সময় উপর থেকে পরিবর্তন করুন.",
  "step.language": "ভাষা", "step.category": "সমস্যা", "step.concern": "সমস্যা",
  "step.profile": "আপনার সম্পর্কে", "step.basic": "আপনার তথ্য", "step.routine": "সুপারিশ",
  "step.delivery": "ডেলিভারি", "step.payment": "পেমেন্ট", "step.review": "পর্যালোচনা",
  "category.title": "আপনি কীসের উপর কাজ করতে চান?",
  "category.subtitle": "এক বা একাধিক বেছে নিন — আমরা মানিয়ে নেব.",
  "category.multiselect": "একাধিক নির্বাচন করুন",
  "category.pickone": "কমপক্ষে একটি বেছে নিন", "category.selected": "নির্বাচিত",
  "concern.title": "আপনার সমস্যা", "concern.subtitle": "আপনি কীসের উপর কাজ করতে চান?",
  "profile.name": "আপনার নাম", "profile.age": "বয়স", "profile.gender": "লিঙ্গ",
  "profile.title": "আপনার সম্পর্কে বলুন", "profile.subtitle": "সঠিক যত্ন দেওয়ার জন্য.",
  "basic.title": "হাই! চলুন শুরু করি.",
  "basic.subtitle": "ব্যক্তিগতকৃত করার আগে কিছু দ্রুত বিবরণ.",
  "basic.phone": "হোয়াটসঅ্যাপ ফোন",
  "gender.female": "নারী", "gender.male": "পুরুষ", "gender.other": "অন্যান্য",
  "recs.title": "আপনার জন্য বাছাই", "recs.subtitle": "আপনার সমস্যার উপর ভিত্তি করে.",
  "recs.combos": "কম্বো", "recs.collections": "সংগ্রহ", "recs.related": "সমস্ত পণ্য",
  "recs.empty": "চালিয়ে যেতে কমপক্ষে একটি যোগ করুন.",
  "routine.added": "যোগ করা হয়েছে", "routine.add": "যোগ", "routine.total": "অর্ডার মোট",
  "routine.title": "আপনার প্রস্তাবিত রুটিন", "routine.subtitle": "আপনার জন্য বাছাই করা.",
  "routine.empty": "চালিয়ে যেতে কমপক্ষে একটি পণ্য বেছে নিন.",
  "delivery.title": "কোথায় পাঠাবো?", "delivery.subtitle": "আমরা আপনার দরজায় পৌঁছাবো.",
  "delivery.phone": "হোয়াটসঅ্যাপ ফোন", "delivery.alt": "বিকল্প ফোন (ঐচ্ছিক)",
  "delivery.address": "সম্পূর্ণ ঠিকানা", "delivery.city": "শহর", "delivery.district": "জেলা",
  "delivery.state": "রাজ্য", "delivery.pincode": "পিনকোড",
  "payment.title": "আপনি কীভাবে পেমেন্ট করতে চান?",
  "payment.online": "অনলাইন পেমেন্ট", "payment.online.note": "ফ্রি ডেলিভারি",
  "payment.cod": "ডেলিভারিতে নগদ", "payment.cod.note": "দরজায় পেমেন্ট করুন", "payment.free": "ফ্রি",
  "review.title": "আপনার অর্ডার পর্যালোচনা করুন",
  "review.subtitle": "সবকিছু ঠিক থাকলে হোয়াটসঅ্যাপে চালিয়ে যান.",
  "review.items": "পণ্য", "review.delivery": "ডেলিভারি", "review.payment": "পেমেন্ট",
  "review.send": "হোয়াটসঅ্যাপে অর্ডার পাঠান",
  "review.consent": "এই অর্ডার সম্পর্কে হোয়াটসঅ্যাপে যোগাযোগ করতে রাজি আছি.",
  "review.yourdetails": "আপনার তথ্য", "review.concerns": "সমস্যা",
  "review.name": "নাম", "review.age": "বয়স", "review.phone": "ফোন", "review.qty": "পরিমাণ",
  "confirm.title": "অর্ডার সম্পন্ন",
  "confirm.subtitle": "আপনার সম্পূর্ণ অর্ডার নিয়ে হোয়াটসঅ্যাপ খোলা হয়েছে.",
  "confirm.confirmed": "নিশ্চিত", "confirm.ref": "অর্ডার রেফারেন্স",
  "confirm.rep": "আপনার পরামর্শদাতা", "confirm.reopen": "হোয়াটসঅ্যাপ আবার খুলুন",
  "confirm.again": "আরেকটি অর্ডার করুন",
  "common.back": "পিছনে", "common.continue": "চালিয়ে যান", "common.skip": "এড়িয়ে যান",
  "common.required": "আবশ্যক", "common.optional": "ঐচ্ছিক", "common.step": "ধাপ",
  "common.of": "/", "common.qty": "পরিমাণ", "common.save": "সংরক্ষণ",
  "common.sending": "পাঠানো হচ্ছে…", "common.loading": "লোড হচ্ছে…",
  "sticky.items": "আইটেম", "sticky.item": "আইটেম",
};

const mr = {
  "brand.name": "एल्व्हिस ब्यूटी",
  "hero.title1": "तुमची त्वचा,", "hero.title2": "तुमचा दिनक्रम.",
  "hero.subtitle": "60 सेकंदाचा कन्सिअर्ज — तुमच्या समस्यांसाठी निवडलेली उत्पादने.",
  "hero.pickLang": "तुमची भाषा निवडा",
  "hero.availability": "10 भाषांमध्ये उपलब्ध. कधीही वरून बदला.",
  "step.language": "भाषा", "step.category": "समस्या", "step.concern": "समस्या",
  "step.profile": "तुमच्याबद्दल", "step.basic": "तुमची माहिती", "step.routine": "शिफारसी",
  "step.delivery": "डिलिव्हरी", "step.payment": "पेमेंट", "step.review": "पुनरावलोकन",
  "category.title": "तुम्हाला कशावर काम करायचे आहे?",
  "category.subtitle": "एक किंवा अधिक निवडा — आम्ही तयार करू.",
  "category.multiselect": "एकाधिक निवडा",
  "category.pickone": "किमान एक निवडा", "category.selected": "निवडले",
  "concern.title": "तुमची समस्या", "concern.subtitle": "तुम्हाला कशावर काम करायचे आहे?",
  "profile.name": "तुमचे नाव", "profile.age": "वय", "profile.gender": "लिंग",
  "profile.title": "तुमच्याबद्दल सांगा", "profile.subtitle": "योग्य दिनक्रम देण्यासाठी.",
  "basic.title": "नमस्कार! सुरुवात करूया.",
  "basic.subtitle": "वैयक्तिकृत करण्यापूर्वी काही जलद माहिती.",
  "basic.phone": "व्हॉट्सअॅप फोन",
  "gender.female": "स्त्री", "gender.male": "पुरुष", "gender.other": "इतर",
  "recs.title": "तुमच्यासाठी निवडलेले", "recs.subtitle": "तुमच्या समस्यांवर आधारित.",
  "recs.combos": "कॉम्बो", "recs.collections": "संग्रह", "recs.related": "सर्व उत्पादने",
  "recs.empty": "सुरू ठेवण्यासाठी किमान एक जोडा.",
  "routine.added": "जोडले", "routine.add": "जोडा", "routine.total": "ऑर्डर एकूण",
  "routine.title": "तुमचा शिफारस केलेला दिनक्रम", "routine.subtitle": "तुमच्यासाठी निवडले.",
  "routine.empty": "सुरू ठेवण्यासाठी किमान एक उत्पादन निवडा.",
  "delivery.title": "कुठे पाठवायचे?", "delivery.subtitle": "आम्ही तुमच्या दारापर्यंत पोहोचवू.",
  "delivery.phone": "व्हॉट्सअॅप फोन", "delivery.alt": "पर्यायी फोन (ऐच्छिक)",
  "delivery.address": "संपूर्ण पत्ता", "delivery.city": "शहर", "delivery.district": "जिल्हा",
  "delivery.state": "राज्य", "delivery.pincode": "पिनकोड",
  "payment.title": "तुम्ही कसे पेमेंट करू इच्छिता?",
  "payment.online": "ऑनलाइन पेमेंट", "payment.online.note": "मोफत डिलिव्हरी",
  "payment.cod": "डिलिव्हरीवर रोख", "payment.cod.note": "दारात पेमेंट करा", "payment.free": "मोफत",
  "review.title": "तुमची ऑर्डर तपासा",
  "review.subtitle": "सर्व बरोबर असल्यास व्हॉट्सअॅपवर सुरू ठेवा.",
  "review.items": "उत्पादने", "review.delivery": "डिलिव्हरी", "review.payment": "पेमेंट",
  "review.send": "व्हॉट्सअॅपवर ऑर्डर पाठवा",
  "review.consent": "या ऑर्डरबद्दल व्हॉट्सअॅपवर संपर्क करण्यास मी सहमत आहे.",
  "review.yourdetails": "तुमची माहिती", "review.concerns": "समस्या",
  "review.name": "नाव", "review.age": "वय", "review.phone": "फोन", "review.qty": "प्रमाण",
  "confirm.title": "ऑर्डर पूर्ण",
  "confirm.subtitle": "तुमच्या संपूर्ण ऑर्डरसह व्हॉट्सअॅप उघडले आहे.",
  "confirm.confirmed": "पुष्टी", "confirm.ref": "ऑर्डर संदर्भ",
  "confirm.rep": "तुमचा सल्लागार", "confirm.reopen": "व्हॉट्सअॅप पुन्हा उघडा",
  "confirm.again": "आणखी ऑर्डर करा",
  "common.back": "मागे", "common.continue": "सुरू ठेवा", "common.skip": "वगळा",
  "common.required": "आवश्यक", "common.optional": "ऐच्छिक", "common.step": "पायरी",
  "common.of": "/", "common.qty": "प्रमाण", "common.save": "जतन करा",
  "common.sending": "पाठवत आहे…", "common.loading": "लोड होत आहे…",
  "sticky.items": "वस्तू", "sticky.item": "वस्तू",
};

const gu = {
  "brand.name": "એલ્વિસ બ્યુટી",
  "hero.title1": "તમારી ત્વચા,", "hero.title2": "તમારી દિનચર્યા.",
  "hero.subtitle": "60 સેકન્ડનો કન્સિયર્જ — તમારી સમસ્યાઓ માટે પસંદ કરેલા ઉત્પાદનો.",
  "hero.pickLang": "તમારી ભાષા પસંદ કરો",
  "hero.availability": "10 ભાષાઓમાં ઉપલબ્ધ. ગમે ત્યારે ઉપરથી બદલો.",
  "step.language": "ભાષા", "step.category": "સમસ્યાઓ", "step.concern": "સમસ્યા",
  "step.profile": "તમારા વિશે", "step.basic": "તમારી વિગતો", "step.routine": "ભલામણો",
  "step.delivery": "ડિલિવરી", "step.payment": "ચુકવણી", "step.review": "સમીક્ષા",
  "category.title": "તમે શેના પર કામ કરવા માંગો છો?",
  "category.subtitle": "એક અથવા વધુ પસંદ કરો — અમે તૈયાર કરીશું.",
  "category.multiselect": "બહુવિધ પસંદ કરો",
  "category.pickone": "ઓછામાં ઓછું એક પસંદ કરો", "category.selected": "પસંદ કરેલ",
  "concern.title": "તમારી સમસ્યા", "concern.subtitle": "તમે શેના પર કામ કરવા માંગો છો?",
  "profile.name": "તમારું નામ", "profile.age": "ઉંમર", "profile.gender": "લિંગ",
  "profile.title": "તમારા વિશે જણાવો", "profile.subtitle": "યોગ્ય દિનચર્યા આપવા માટે.",
  "basic.title": "નમસ્તે! ચાલો શરૂ કરીએ.",
  "basic.subtitle": "વ્યક્તિગતકરણ પહેલા થોડી ઝડપી વિગતો.",
  "basic.phone": "વોટ્સએપ ફોન",
  "gender.female": "સ્ત્રી", "gender.male": "પુરુષ", "gender.other": "અન્ય",
  "recs.title": "તમારા માટે પસંદગી", "recs.subtitle": "તમારી સમસ્યાઓ આધારે.",
  "recs.combos": "કોમ્બો", "recs.collections": "સંગ્રહ", "recs.related": "બધા ઉત્પાદનો",
  "recs.empty": "ચાલુ રાખવા ઓછામાં ઓછું એક ઉમેરો.",
  "routine.added": "ઉમેરાયું", "routine.add": "ઉમેરો", "routine.total": "ઓર્ડર કુલ",
  "routine.title": "તમારી ભલામણ કરેલી દિનચર્યા", "routine.subtitle": "તમારા માટે પસંદ કરેલી.",
  "routine.empty": "ચાલુ રાખવા ઓછામાં ઓછું એક ઉત્પાદન પસંદ કરો.",
  "delivery.title": "ક્યાં મોકલવાનું છે?", "delivery.subtitle": "અમે તમારા દરવાજે પહોંચાડીશું.",
  "delivery.phone": "વોટ્સએપ ફોન", "delivery.alt": "વૈકલ્પિક ફોન (વૈકલ્પિક)",
  "delivery.address": "પૂરું સરનામું", "delivery.city": "શહેર", "delivery.district": "જિલ્લો",
  "delivery.state": "રાજ્ય", "delivery.pincode": "પિનકોડ",
  "payment.title": "તમે કેવી રીતે ચૂકવણી કરવા માંગો છો?",
  "payment.online": "ઓનલાઇન ચૂકવણી", "payment.online.note": "મફત ડિલિવરી",
  "payment.cod": "ડિલિવરી પર રોકડ", "payment.cod.note": "દરવાજે ચૂકવણી કરો", "payment.free": "મફત",
  "review.title": "તમારો ઓર્ડર સમીક્ષા કરો",
  "review.subtitle": "બધું બરાબર હોય તો વોટ્સએપ પર ચાલુ રાખો.",
  "review.items": "ઉત્પાદનો", "review.delivery": "ડિલિવરી", "review.payment": "ચૂકવણી",
  "review.send": "વોટ્સએપ પર ઓર્ડર મોકલો",
  "review.consent": "આ ઓર્ડર વિશે વોટ્સએપ પર સંપર્ક કરવા સંમત છું.",
  "review.yourdetails": "તમારી વિગતો", "review.concerns": "સમસ્યાઓ",
  "review.name": "નામ", "review.age": "ઉંમર", "review.phone": "ફોન", "review.qty": "જથ્થો",
  "confirm.title": "ઓર્ડર થઈ ગયો",
  "confirm.subtitle": "તમારા સંપૂર્ણ ઓર્ડર સાથે વોટ્સએપ ખુલ્યું છે.",
  "confirm.confirmed": "પુષ્ટિ", "confirm.ref": "ઓર્ડર સંદર્ભ",
  "confirm.rep": "તમારા સલાહકાર", "confirm.reopen": "વોટ્સએપ ફરી ખોલો",
  "confirm.again": "બીજો ઓર્ડર કરો",
  "common.back": "પાછા", "common.continue": "ચાલુ રાખો", "common.skip": "છોડો",
  "common.required": "જરૂરી", "common.optional": "વૈકલ્પિક", "common.step": "પગલું",
  "common.of": "/", "common.qty": "જથ્થો", "common.save": "સાચવો",
  "common.sending": "મોકલી રહ્યું છે…", "common.loading": "લોડ થઈ રહ્યું છે…",
  "sticky.items": "વસ્તુઓ", "sticky.item": "વસ્તુ",
};

const dict = { en, hi, kn, ta, ml, te, bn, mr, gu, other: en };

const FALLBACK = "en";

export function t(lang, key) {
  if (dict[lang] && dict[lang][key] != null) return dict[lang][key];
  if (dict[FALLBACK][key] != null) return dict[FALLBACK][key];
  return key;
}

export { SUPPORTED };
export default dict;
